webpackJsonp([162898551421021],{

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	var _StyledLink = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Haiku = _Layout.Text.withComponent('pre', {
	  target: 'e19mohww0'
	});
	
	var errorPage = function errorPage() {
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'No such page'
	      )
	    ),
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _Typography.Title,
	        { fontSize: [4, 5], fontWeight: '7', lineHeight: 'title', mt: 0, mb: 3 },
	        'Error 404'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        {
	          fontSize: [3, 4],
	          fontWeight: '5',
	          lineHeight: 'title',
	          mt: 3,
	          mb: 4
	        },
	        'The page you\u2019re looking for does not exist.'
	      ),
	      _react2.default.createElement(_Typography.Rule, { mt: 4, mb: 5 })
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        Haiku,
	        { fontSize: [2, 3], fontFamily: 'monospace', lineHeight: 'title' },
	        'I\u2019m sorry. ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/', text: 'Click here to go home' }),
	        '.',
	        _react2.default.createElement('br', null)
	      )
	    )
	  );
	};
	
	exports.default = errorPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-f7d03b790320da567ab5.js